import React from "react";
import Main from "../components/Main";
import InternalSurvey from "../components/InternalSurvey/InternalSurvey";
// import { factors } from "../data/chartData";

export default class extends React.Component {
  render() {

    return (
      <div className="page">
        <InternalSurvey facets="Countries"/>
        <InternalSurvey facets="Business Divisions"/>
        <InternalSurvey facets="Gender"/>
        <InternalSurvey facets="Corporate Title"/>
        <InternalSurvey facets="Being a Line Manager"/>
        <InternalSurvey facets="Length of Service"/>

        <style jsx global>{`
          html, body {
            height: 100%;
          }
          body {
            background: #fff;
            margin: 0;
            text-rendering: optimizeLegibility;
            -webkit-font-smoothing: antialiased;
            -moz-font-smoothing: grayscale;
          }
          .page {
            padding: 20px;
          }
        `}</style>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/internal-survey.js